import React, {useRef, useState} from 'react';
import './../css/Style.css';
import './../css/complaint-management.css';
import 'font-awesome/css/font-awesome.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faSpinner } from '@fortawesome/free-solid-svg-icons';
import usePDFDownload from '../hooks/usePDFDownload'; // Add this import

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fontsource/poppins';

import './../css/StyleV3.css';
import './../css/StyleV2.css';
import './../css/order.css';
import OrderCreated from "../images/Orders/Order_Created.svg";
import SubscriptionReceivedActive from "../images/Orders/Subscription-Received-Active.svg";
import RenewalChannels from "../images/Orders/Renewal_channels.svg";
import SubscriptionApproved from "../images/Orders/Subscription-Approved.svg";
import SubscriptionApprovedActive from "../images/Orders/Subscription-Approved-Active.svg";
import PaymentStatus from "../images/Orders/Payment-Status.svg";
import PaymentStatusActive from "../images/Orders/Payment-Status-Active.svg";
import CouponsIssued from "../images/Orders/Coupons-Issued.svg";
import CouponsIssuedActive from "../images/Orders/Coupons-Issued-Active.svg";
import CouponsDispatch from "../images/Orders/Coupons-Dispatch.svg";
import CouponsDispatchActive from "../images/Orders/Coupons-Dispatch-Active.svg";

import booking_icon from '../images/success-page/booking-icon.svg';
import gift_icon from '../images/success-page/gift-icon.svg';
import publication_icon from '../images/success-page/publication-icon.svg';
import coupon_icon from '../images/success-page/coupon-icon.svg';
import delivery_icon from '../images/success-page/delivery-icon.svg';

import Moment from 'moment';
import Popper from '@mui/material/Popper';
import { Modal } from 'react-bootstrap';
import { planNames, getDeliveryStatus } from '../utils/utils.js';

const userInfo = JSON.parse(sessionStorage.getItem('orderDetails')) || {
    ciName: '',
    ciCode: '',
    ciMobile: '',
    centerName: ''
};

const details = [];

function OrderDetails ({ isOpenDetail, onCloseDetail, orderDetail, orderStages, orderKey=0 }) {
    // Replace the old state with the hook
    const { downloadPDF, downloadPDFWithInstructions, downloadPDFFromURL, isDownloading } = usePDFDownload();

    const stageInfo = {
        subscriptionReceived: {
            imgSrc: {
                'Inactive': OrderCreated,
                'Active': SubscriptionReceivedActive,
            },
            text: 'Subscription Received',
        },
        
        paymentStatus: {
            imgSrc: 
            {
                'Inactive': PaymentStatus,
                'Active': PaymentStatusActive,
            },
            text: 'Payment Status',
        },
        startDate: {
            imgSrc: 
            {
                'Inactive': SubscriptionApproved,
                'Active': SubscriptionApprovedActive,
            },
            text: 'NewsPaper Start Date',
        },
        couponDetail: {
            imgSrc: 
            {
                'Inactive': CouponsIssued,
                'Active': CouponsIssued,
            },
            text: 'Coupons Detail',
        }
    };

    const initialOpenTooltipsState = {}; // Create an object to manage each tooltip's open state

    // Assuming you have an array of keys or stageInfo keys
    Object.keys(stageInfo).forEach((key) => {
        initialOpenTooltipsState[key] = false; // Initialize each key to false
    });
    
    const [openTooltips, setOpenTooltips] = useState(initialOpenTooltipsState);
    const [openPopper, setOpenPopper] = useState({}); // State to manage which Popper is open
    const [touchStart, setTouchStart] = useState(false);

    const handleTouchStart = (key, event) => {
        setTouchStart(true); // Mark touchStart as true to prevent onClick
        handleClick(key, event); // Call your existing click handler
    };
    const handleMouseEnter = (key, event) => {
        const anchor = event.currentTarget;
        setOpenPopper((prev) => ({
            ...prev,
            [key]: anchor instanceof HTMLElement ? anchor : null,
        }));
    };
    
    const handleClick = (key, event) => {
        event.stopPropagation();
        if (touchStart) {
            setTouchStart(false); // Reset touchStart to false after the first touch event
            return; // Prevent the onClick from firing after touch
        }
        const anchor = event.currentTarget;
        setOpenPopper((prev) => ({
            ...prev,
            [key]: prev[key] ? null : anchor instanceof HTMLElement ? anchor : null,
        }));
    };
    
    const handleMouseLeave = (key) => {
        setOpenPopper((prev) => ({
            ...prev,
            [key]: null, // Clear anchor on leave
        }));
    };

    if (!isOpenDetail) return null;

    let letter = "A"; // Ensure `i` is defined in scope
    let isStageEmpty = false;
    let couponType = "";
    let button = "";

    if (orderDetail) {
        const i = orderKey; // Assuming 'i' is part of your logic
        letter = String.fromCharCode(65 + i);

        // isStageEmpty = orderDetail.stage && Object.keys(orderDetail.stage).length === 0;
        isStageEmpty = !orderStages || (typeof orderStages === 'object' && Object.keys(orderStages).length === 0);

        if (orderDetail.couponPreference !== null) {
            if (orderDetail.couponPreference.includes("M")) {
                couponType = "Digital Coupon";
            } else {
                couponType = "Physical Coupon";
            }
        } else {
            couponType = "";
        }
    }
    const bookinFormNumber = orderDetail?.bookingFormNumber;
    const bookingNumber = bookinFormNumber || '-';
    const gift = bookinFormNumber && orderDetail?.gifts[0]?.name ? orderDetail?.gifts[0]?.name : '-';
    const deliveryMode = bookinFormNumber ? getDeliveryStatus('3') : '-';
    const publication = bookinFormNumber ? orderDetail?.scheme?.publications : '-';
    const couponPref = bookinFormNumber && orderDetail?.couponPreference ? orderDetail?.couponPreference : " - ";

    const details = [
        { label: 'Selected gift name', value: gift, icon: gift_icon },
        { label: 'Delivery mode', value: deliveryMode, icon: delivery_icon },
        { label: 'Publication', value: planNames[publication] || publication, icon: publication_icon },
        { label: 'Booking Form Number', value: bookingNumber, icon: booking_icon },
        { label: 'Coupon preference', value: couponPref, icon: coupon_icon },
    ];

    const templateData = {
        publication: planNames[orderDetail.scheme.publications] ? planNames[orderDetail.scheme.publications] : orderDetail.scheme.publications,
        subscriptionPeriod: orderDetail?.scheme?.duration || ' - ',
        details
    };

    // Replace the handleDownloadPDF function
    const handleDownloadPDF = async () => {
        const bookingFormNumber = orderDetail?.bookingFormNumber; // Use actual booking form number
        
        // Try the main method first (converts HTML response to PDF)
        const success = await downloadPDF(bookingFormNumber, {
            filename: `HT-Booking-Form-${bookingFormNumber}.pdf`,
            onSuccess: () => {
                console.log('PDF download completed successfully');
            },
            onError: async (error, message) => {
                console.error('Primary method failed:', error);
                
                // If primary fails, try URL-based conversion
                console.log('Trying URL-based conversion...');
                const urlSuccess = await downloadPDFFromURL(bookingFormNumber, {
                    filename: `HT-Booking-Form-${bookingFormNumber}.pdf`,
                    onSuccess: () => {
                        console.log('URL-based PDF conversion completed');
                    },
                    onError: (urlError, urlMessage) => {
                        console.error('URL-based conversion failed:', urlError);
                        
                        // If both fail, use fallback method
                        console.log('Using fallback method...');
                        downloadPDFWithInstructions(bookingFormNumber, {
                            onSuccess: () => {
                                console.log('Opened in new window for manual download');
                            },
                            onError: (fallbackError, fallbackMessage) => {
                                console.error('All methods failed:', fallbackError);
                                alert('Unable to download booking form. Please contact support.');
                            }
                        });
                    }
                });
            }
        });
    };

    return (
        <>
            <Modal
                show={isOpenDetail}
                onHide={onCloseDetail}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                id="order-details"
                key={orderDetail.id}
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title className="CITitle">Order Details</Modal.Title> */}
                </Modal.Header>
                <Modal.Body onClick={(e) => e.stopPropagation()} style={{ padding: '0px' }}>
                        <div className="order-management" style={{ color: 'black' }}>
                            {orderDetail ? (
                                <div className="card">
                                    <div className="card-body">
                                        <div className="order-item">
                                            <div className="type">
                                                <span variant="body1">
                                                    {couponType}
                                                </span>
                                            </div>

                                            <div className="order-first-first">
                                                <span className="mr-3">{planNames[orderDetail.scheme.publications] ? planNames[orderDetail.scheme.publications] : orderDetail.scheme.publications}</span>
                                                <span className={`Dot ${orderDetail.status ? orderDetail.status + 'Dot' : 'greenDot'}`}></span>
                                                <span className="last">{orderDetail.status}</span>
                                            </div>
                                            <div className="order-first-second mb-3 mt-2">
                                                <div className="order-publication-div">
                                                    <span className="fSec-head">Publication:</span>
                                                    <span className="fSec-title">{planNames[orderDetail.scheme.publications] ? planNames[orderDetail.scheme.publications] : orderDetail.scheme.publications}</span>
                                                </div>
                                                <span className="separator"></span>
                                                <div className="order-plan-div">
                                                    <span className="fSec-head">Plan:</span>
                                                    <span className="fSec-title">{Math.floor(orderDetail.scheme.duration) || 'NA'} Months</span>
                                                </div>
                                                {(orderDetail.order_start_date && orderDetail.order_end_date) && (
                                                    <>
                                                    <span className="separator"></span>
                                                    <div className="order-expiry-div">
                                                        <span className="fSec-head">Dates:</span>
                                                        <span className="fSec-title">{orderDetail.order_start_date ? Moment(orderDetail.order_start_date).format('DD.MM.YYYY') : 'NA'} - {orderDetail.order_end_date ? Moment(orderDetail.order_end_date).format('DD.MM.YYYY') : 'NA'}</span>
                                                    </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        {
                                            !isStageEmpty &&
                                            <div>
                                                <div className="order-second">
                                                    {Object.entries(orderStages).map(([key, value]) => {
                                                    let isActive = '';
                                                    let title = '';
                                                    let imgStatus = 'Inactive';
                                                    let couponDispatchDetail = '';
                                                    if (typeof value === 'boolean' && value) {
                                                        isActive = 'active';
                                                        imgStatus = 'Active';
                                                    }else if (value && typeof value === 'string' && key == 'startDate') {
                                                        isActive = 'active';
                                                        title = `Start Date: ${value}`;
                                                    }else if (Array.isArray(value) && value.length > 0 && (value[0].status || value[0].status === 'Success')) {
                                                        isActive = 'active';
                                                        imgStatus = 'Active';
                                                        if (key === 'paymentStatus') {
                                                            title = `status: ${value[0].status} | transactionId: ${value[0].transactionId} | mode: ${value[0].mode}`;
                                                        }
                                                    } else if (typeof value === 'object' && value !== null && (value.status || value.status === 'Success')) {
                                                        isActive = 'active';
                                                        imgStatus = 'Active';
                                                        if (key === 'paymentStatus') {
                                                            title = `status: ${value.status} | transactionId: ${value.transactionId} | mode: ${value.mode}`;
                                                        }
                                                        
                                                    }else if (typeof value === 'object' && value !== null && key === 'couponDetail') {
                                                        isActive = 'active';
                                                        if (key === 'couponDetail') {
                                                            couponDispatchDetail = '';
                                                        
                                                            if (value.couponDispatchDetail && typeof value === 'object' && value.couponDispatchDetail !== null) {
                                                                const dispatchDetails = Object.entries(value.couponDispatchDetail)
                                                                    .filter(([_, disValue]) => disValue !== null)  // filter out null values
                                                                    .map(([disKey, disValue]) => `${disKey}: ${disValue}`) // format the details
                                                                    .join(' | '); // join them with " | "
                                                        
                                                                // Only add Delivery Status if there are details
                                                                if (dispatchDetails) {
                                                                    couponDispatchDetail = `| Delivery Status: ( ${dispatchDetails} )`;
                                                                }
                                                            }
                                                        }

                                                        title = `Type: ${value.couponType || ' - '} | Number: ${value.couponNumber || ' - '} ${couponDispatchDetail}`;

                                                    }

                                                    return (
                                                        <div 
                                                            key={key} 
                                                            className={`order-second-first ${isActive}`} 
                                                            data-id={key + " - " + value}
                                                            onMouseEnter={(event) => handleMouseEnter(key, event)} // Move hover to div
                                                            onMouseLeave={() => handleMouseLeave(key)} // Move hover out to div
                                                            onTouchStart={(event) => handleTouchStart(key, event)} // Move touch to div
                                                            onClick={(event) => handleClick(key, event)} // Move click to div
                                                        >
                                                            <img
                                                                className="img"
                                                                src={stageInfo[key].imgSrc['Inactive']} // Use imgStatus instead of 'Inactive'
                                                                alt={stageInfo[key].imgSrc['Inactive']}
                                                            />
                                                            {openPopper[key] && title && (
                                                                <Popper
                                                                    open={Boolean(openPopper[key])}
                                                                    anchorEl={openPopper[key] instanceof HTMLElement ? openPopper[key] : null}
                                                                    placement="top"
                                                                    modifiers={{
                                                                        preventOverflow: {
                                                                            enabled: true,
                                                                            options: {
                                                                                padding: 8,
                                                                            },
                                                                        },
                                                                        offset: {
                                                                            enabled: true,
                                                                            offset: '0, 10', // Adjust the offset if needed
                                                                        },
                                                                    }}
                                                                    style={{
                                                                        zIndex: 1300,
                                                                        top: 54 // Set the z-index directly here
                                                                    }}
                                                                >
                                                                    <div className="tooltip-content">
                                                                        {title}
                                                                    </div>
                                                                </Popper>
                                                            )}

                                                            <span className="text">{stageInfo[key].text}</span>
                                                        </div>
                                                    );
                                                    })}

                                                </div>
                                            </div>
                                        }
                                        <div className="successBtn">
                                            <button className="download-form" 
                                                style={{
                                                    font: "normal normal 600 12px / 35px Poppins",
                                                    cursor: isDownloading ? 'not-allowed' : 'pointer',
                                                    opacity: isDownloading ? 0.6 : 1
                                                }} 
                                                disabled={isDownloading} 
                                                onClick={handleDownloadPDF}
                                            >
                                                {!isDownloading ? (
                                                <FontAwesomeIcon icon={faDownload} style={{ fontSize: '20px'}} className="faDownload" />
                                                ) : (
                                                <FontAwesomeIcon icon={faSpinner} style={{ fontSize: '20px'}} className="faDownload" />
                                                )}
                                                <span className='ml-2'>DOWNLOAD BOOKING FORM</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <p>No Center Details Available!</p>
                            )}
                        </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default OrderDetails;
